import React, { useContext, useEffect } from 'react';
import useOnChange from '../../../../hooks/useChange';
import { ContextBuilder } from "../../../../context/builder/reducers";
import arrayMove from 'array-move';
import SortableList, { SELECTED_EMPLOYEES_ITEM } from '../SortableList';
import Input from '../Input';
import axios from "axios";

const SelectedEmployees = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {
                title: '',
                elements: []
            }
            dispatch({ type: 'data', payload: { data } })
        }
    });

    useEffect(() => {
        axios.get('/admin/employees').then(({ data }) => {
            dispatch({ type: 'data', payload: { employees: data } });
        });
    }, [props.index]);

    let elements = props.content.elements || [];
    let title = props.content.title;

    const addItem = () => {
        const data = state.data;
        elements = [...elements, { text: '', img: '', title: '' }];
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const data = state.data;
        elements = arrayMove(elements, oldIndex, newIndex);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const deleteButtonHandler = (e) => {
        const index = e.currentTarget.getAttribute('index');
        const data = state.data;
        elements.splice(index, 1);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    return (
        <SortableList
            item={SELECTED_EMPLOYEES_ITEM}
            titleComponent="Selected employees"
            type={props.type}
            elements={elements}
            onChange={onChange}
            onSortEnd={onSortEnd}
            addItem={addItem}
            deleteButtonHandler={deleteButtonHandler}
            axis="xy"
            useDragHandle
        >
            <div className="form-group">
                <label>Title</label>
                <Input onChange={onChange} name="title" value={title || ''}/>
            </div>
        </SortableList>);
}

export default SelectedEmployees;
